const expiration = 1000 * 60 * 60 * 24; // 24 hours in milliseconds
const VERIFIED_KEY = "verified";
const RESEND_CODE_KEY = "resendCode";
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const debug = urlParams.get("debug") ?? "";

export const getVerifiedValue = () => {
  const lsVerified = localStorage.getItem(VERIFIED_KEY);
  try {
    const json = JSON.parse(lsVerified);
    if (debug) {
      console.debug("getVerifiedValue:", JSON.stringify(json));
    }
    return json || {};
  } catch (e) {
    return {};
  }
};

export const setVerifiedValue = (username, timestamp) => {
  const verified = getVerifiedValue();
  verified[username] = timestamp;
  localStorage.setItem(VERIFIED_KEY, JSON.stringify(verified));
};

export const isUserVerified = (username) => {
  const verified = getVerifiedValue();
  const now = new Date().getTime();
  try {
    const timestamp = verified[username];
    if (timestamp) {
      if (now - timestamp < expiration) {
        console.log("User already verified:", username);
        return true;
      } else {
        console.log("User verification expired:", username);
        delete verified[username];
        setVerifiedValue(verified);
      }
    }
    return false;
  } catch (e) {
    console.error("Error parsing verified users:", e);
    return false;
  }
};

const getResendCodeValue = () => {
  const lsResendCode = localStorage.getItem(RESEND_CODE_KEY);
  try {
    return lsResendCode ? JSON.parse(lsResendCode) : {};
  } catch (e) {
    return {};
  }
};

export const setResendCodeValue = (username, timestamp) => {
  const resendCode = getResendCodeValue();
  resendCode[username] = timestamp;
  localStorage.setItem(RESEND_CODE_KEY, JSON.stringify(resendCode));
};

export const isResendCodeActive = (username) => {
  const resendCode = getResendCodeValue();
  const now = new Date().getTime();
  try {
    const timestamp = resendCode[username];
    if (timestamp) {
      if (now - timestamp < expiration) {
        console.log("Code already sent:", username);
        return true;
      } else {
        console.log("Code resend expired:", username);
        delete resendCode[username];
        setResendCodeValue(resendCode);
      }
    }
    return false;
  } catch (e) {
    console.error("Error parsing resend codes:", e);
    return false;
  }
};
